
const C = 'PURCHASE_SHOW_PURCHASE_DETAIL';

export default {
  FETCH_PURCHASE_ORDER: `${C}.FETCH_PURCHASE_ORDER`,
  CANCEL_FETCH_PURCHASE_ORDER: `${C}.CANCEL_FETCH_PURCHASE_ORDER`,
  CHANGE_PURCHASE_ORDER: `${C}.CHANGE_PURCHASE_ORDER`,
  RESET_DATA: `${C}.RESET_DATA`,
}
